import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { EditorService } from './modules/editor.service';
import { ClassifyService } from './modules/classify.service';
import { SplittedService } from '../project-spliting/modules/splited.service';
import { FloatWindowComponent } from 'src/app/back-office/components/float-window/float-window.component';
import config from 'config/default.json';
@Component({
  selector: 'app-project-editing',
  templateUrl: './project-editing.component.html',
  styleUrls: ['./project-editing.component.scss'],
  providers: [SplittedService, ClassifyService, EditorService]
})
export class ProjectEditingComponent{
  constructor(
    
    public dialogRef: MatDialogRef<ProjectEditingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { [x:string]: any },
    private renderer: Renderer2,
    private elRef: ElementRef,
    private cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    private apiService: ApiServiceModule,
    public dialog: MatDialog,
    public sanitizer: DomSanitizer,
    public splittedService: SplittedService,
    public classifyService: ClassifyService,
    public editorService: EditorService
    ) {}

    PDFJS = (window as { [key: string]: any })["pdfjs-dist/build/pdf"];
    userInfos: { [x:string]: any } = this.data['user_infos'];
    projectInfos: {[x: string]: any} = this.data['project'];
    contentData: { [x:string]: any }[] = this.data['content_data'];
    classifyData: { [x:string]: any }[] = this.data['classify_data'];
    platformInfos: any = this.data['platform_infos'];
    source: string = this.data['source'];
    widthListZone: number = 40;


    inProgress = false;
    splittedActive = false;
    editedActive = false;
    classifiedActive = false;
    currentTask = ''
    taskLabels:{[x: string]: any}= {
      'task-splitted': 'Content Splitted',
      'task-editing': 'Content Editing',
      'task-classified': 'Content Classification'
    }

    ngAfterViewInit(){
      this.widthListZone = this.contentData.length > 1? 40: 0;
      this.contentData = this.contentData.map((row:any) => {
        row['year_name'] = [4, 5, 7].includes(row['id_section'])  ? ((row['id_content_learning'] ?? '')  + ' ' + (row['content_name'] ?? '')) : (row['year'] ?? '');
        row['type_chapter'] = row['id_section'] == 4  ? (row['chapter'] ?? '')  : ((row['id_content_replace']? `R:${row['id_content_replace']}`: '') + ' ' +(row['id_content_subject'] ?? '') + ' ' + (row['type'] ?? '')); 
        row['label'] = this.platformInfos.key == 'vca'? (row['section'] ?? '') + ' '+ (row['module'] ?? '') + ' - '+ (row['semester'] ?? '') + ' - '+ row['year_name'] + ' - '+ row['type_chapter']:
                      (row['class'] ?? '') + ' '+ (row['study'] ?? '') +': '+(row['section'] ?? '') + ' '+ (row['module_full_name'] ?? '') + ' - '+ (row['period'] ?? '') + ' - '+ row['year_name'] + ' - '+ row['type_chapter'];
        return row;
      });
      
      this.editorService.init(this);
      this.splittedService.init(this);
      this.classifyService.init(this);
      this.currentTask= this.projectInfos['last_task'];
      if(this.currentTask == 'task-splitted') this.splittedService.showSplitted();
      if(this.currentTask == 'task-editing') this.editorService.showEdited();
      if(this.currentTask == 'task-classified') this.classifyService.showClassified();
    }

    buildProcess(){
      if(this.splittedService) this.splittedService.computeAutoEditing();
    }
    outputEmiter(data:any){
      if(this.splittedService) this.splittedService.computeAutoEditing(data);
    }
    showSampleContent(){
      const dialogRef = this.dialog.open(FloatWindowComponent, {
        maxWidth: '100vw',
              height: '100%',
              width: '100%',
              panelClass: 'full-screen-modal',
        position: {top: '30px' },
        data: {action: 'show-content', source: 'master', page_origin: 'show-editor-pdf', show_mode: 'docx-show', file_urls: [{id_content: 0, url: config.master.ndapi.url + '/sample_content_integration.pdf'}], docx_file: config.master.ndapi.url + '/sample_content_integration.docx', user_infos: this.userInfos}
      });
    
      dialogRef.afterClosed().subscribe((toContinue:boolean) => {
        if(toContinue){
          
        }
      });
    }
    
    onClose(): void {
      this.dialogRef.close();
    }
    activatePage(page:string){
      this.currentTask = page;
      this.splittedActive = this.currentTask == 'task-splitted'? true: false;
      this.editedActive = this.currentTask == 'task-editing'? true: false;
      this.classifiedActive = this.currentTask == 'task-classified'? true: false;
      this.cdRef.detectChanges();
    }
    removeChildsFromElement(element:any){
      while (element.hasChildNodes()) {
        element.removeChild(element.lastChild);
      }
    }
}
